<template>
    <page-state
        title="Sua área, com acesso seguro"
        description="Entre na sua conta para consultar suas informações. Ainda não tem conta? Crie a sua em Entrar, ou envie seu primeiro pedido de habilitação ou divergência, que a conta é criada junto."
        icon="mdi-lock-outline"
    >
        <div class="access-notice__actions">
            <v-btn color="primary" class="pbb-btn" @click="openAccess">Entrar na minha conta</v-btn>
            <v-btn text color="primary" class="pbb-btn" to="/habilitacoes-divergencias/novo"
                >Enviar habilitação ou divergência
                <v-icon right size="18">mdi-arrow-right</v-icon></v-btn
            >
        </div>
    </page-state>
</template>
<script>
import { eventHub } from '@/main';
export default {
    name: 'CreditorAccessNotice',
    methods: {
        openAccess() {
            eventHub.$emit('DIALOG-ACCESS-FORM', true);
        }
    }
};
</script>
